import { useEffect, useRef, useState } from "react";

const useAnimatedCounter = (
  targetValue: number | string,
  duration = 600,
  reverseStart?: number
) => {
  const [value, setValue] = useState(0);
  const prev = useRef(0);
  const firstLoad = useRef(true);

  useEffect(() => {
    const end = Number(targetValue) || 0;
    let start = prev.current;

    if (firstLoad.current) {
      start = reverseStart ?? end + 20;
      setValue(start);
      prev.current = start;
      firstLoad.current = false;
    }

    if (start === end) return;

    const diff = Math.abs(end - start);
    const stepTime = Math.max(duration / diff, 20);
    const direction = end > start ? 1 : -1;

    let current = start;

    const interval = setInterval(() => {
      current += direction;

      if (
        (direction === 1 && current >= end) ||
        (direction === -1 && current <= end)
      ) {
        current = end;
        clearInterval(interval);
      }

      setValue(current);
      prev.current = current;
    }, stepTime);

    return () => clearInterval(interval);
  }, [targetValue, duration, reverseStart]);

  return value;
};

export default useAnimatedCounter;
